import axios from 'axios';
import { API_BASE_URL } from '../config/constant';

export const LoginService = async (data) => {
    return await axios.post(API_BASE_URL + 'login', data);
}

export const VerifyOtpService = async (data) => {
    return await axios.post(API_BASE_URL + 'otp_verify', data);
}

export const GetCountriesService = async () => {
    return await axios.get(API_BASE_URL + 'get_countries');
}

export const ExchangeLoginTokenService = async (token) => {
    return await axios.post(API_BASE_URL + 'exchange-login-token', { token });
}